export const MODAL_DATA_PARAM = 'md';
export const MODAL_PARAM = 'm';
export const PUSHED_MODAL_HISTORY_STATE = '__pushedModalEntry';
// Number of in-modal steps above the entry that opened the modal.
export const MODAL_HISTORY_STEPS_STATE = '__modalHistorySteps';
